import { Form } from "antd/es";
import { PureComponent, ReactNode } from "react";
import KuikaInput from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaRadioGroup from "../../../../ui-kit/kuika-radio-group/kuika-radio-group";
import { ConfigField } from "../config-pane-parts";

const CREDENTIAL_MODES: { label: string; value: string }[] = [
  { label: "Default", value: "default" },
  { label: "Custom", value: "custom" }
];

export class ConfigSwaggerUiInput extends PureComponent {
  render(): ReactNode {
    return (
      <Form.Item
        shouldUpdate={(prev, current) =>
          prev.apiConfig?.useSwaggerUi !== current.apiConfig?.useSwaggerUi ||
          prev.swaggerUiMode !== current.swaggerUiMode
        }
        noStyle
      >
        {({ getFieldValue }) => {
          const enabled: boolean = getFieldValue(["apiConfig", "useSwaggerUi"]);
          if (!enabled) return null;

          const mode: string = getFieldValue(["swaggerUiMode"]) ?? "default";

          return (
            <>
              <ConfigField label="Swagger UI Credentials">
                <Form.Item name={["swaggerUiMode"]} noStyle>
                  <KuikaRadioGroup options={CREDENTIAL_MODES} />
                </Form.Item>
              </ConfigField>

              {mode === "custom" && (
                <>
                  <ConfigField label="Username" required>
                    <Form.Item
                      name={["apiConfig", "swaggerUiUsername"]}
                      rules={[{ whitespace: true, required: true, message: "Username is required." }]}
                    >
                      <KuikaInput size="md" placeholder="Username" autoComplete="off" />
                    </Form.Item>
                  </ConfigField>

                  <ConfigField label="Password" required>
                    <Form.Item
                      name={["apiConfig", "swaggerUiPassword"]}
                      rules={[{ whitespace: true, required: true, message: "Password is required." }]}
                    >
                      <KuikaInput size="md" type="password" placeholder="Password" autoComplete="new-password" />
                    </Form.Item>
                  </ConfigField>
                </>
              )}
            </>
          );
        }}
      </Form.Item>
    );
  }
}
